module.exports = __webpack_public_path__ + "static/media/anders.726aaa38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/anders.jpg
// module id = 602
// module chunks = 0